var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    "aria-labelledby": titleId,
    fill: "#0057B8",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "calender"
  }, "Calendar Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "calender"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35 3.1v-3h2v3h11v44h-48v-44h11v-3h2v3h10v-3h2v3h10zm0 2h-10v3h-2v-3h-10v3h-2v-3h-9v40h44v-40h-9v3h-2v-3zm-33 14v-2h44v2h-44z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.67c30023d522b67cc5d18189e7dfec5e.svg";
export { ForwardRef as ReactComponent };